// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"ProductAvailabilityIcon_paginationPageDropdownWrap__iVvR7","ProductAvailabilityIcon":"ProductAvailabilityIcon_ProductAvailabilityIcon__RgYee"};